import api from "@/apis/AllocationReduceEmployeeAPI";
import Crud from "./crud-base";
var crud = new Crud("AllocationReduceEmployee", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "EmployeeID",
      code: "EmployeeCode",
      name: "FullName",
    },
  },
};
const getters = {
  ...crud.getters,
};
const mutations = {
  ...crud.mutations,
};

const actions = {
  ...crud.actions,
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
